import axios from "axios";
import localStorageService from "./localStorageService";
import {refreshToken, signin} from "./AuthService";
import {getUserProfile} from "./UserService";

class JwtAuthService {

    async loginWithEmailAndPassword({email, password}) {
        const signinResponse = await signin({
            username: email,
            password: password
        })

        if (signinResponse.data?.accessToken) {

            const userProfileResponse = await getUserProfile(
                signinResponse.data?.accessToken
            )

            const user = userProfileResponse.data
            user.role = 'ADMIN'

            this.setSession(signinResponse.data?.accessToken)
            this.setUser(user)

            return {user, accessToken: signinResponse.data?.accessToken}
        }
        throw new Error("Wrong email or password");
    }

    async loginWithToken() {
        const currentToken = localStorage.getItem("jwt_token", true)

        axios.defaults.headers.common["Authorization"] = "Bearer " + currentToken;

        const response = await refreshToken({
            token: currentToken
        })
        this.setSession(response.data?.accessToken)
        const user = localStorageService.getItem("auth_user")
        return user;
    }

    logout() {
        this.setSession(null);
        this.removeUser();
    }

    setSession(token) {
        if (token) {
            localStorage.setItem("jwt_token", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        } else {
            localStorage.removeItem("jwt_token");
            delete axios.defaults.headers.common["Authorization"];
        }
    }

    setUser(user) {
        localStorageService.setItem("auth_user", user);
    }

    removeUser() {
        localStorage.removeItem("auth_user");
    }
}

const service = new JwtAuthService();
export default service;
